import { render, staticRenderFns } from "./Types.vue?vue&type=template&id=07530bc4"
import script from "./Types.vue?vue&type=script&lang=js"
export * from "./Types.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports